// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"86b73434","977":"86b73434"}[chunkId] + ".chunk.css";
};